// ---------------------------------------------------------------------------
// PWA_ControlBillet — Application constants
// ---------------------------------------------------------------------------

// --- Timers & intervals (ms) -----------------------------------------------

/** How often the heartbeat pings the backend. */
export const HEARTBEAT_INTERVAL = 10_000;

/** How often queued offline validations are pushed to the backend. */
export const SYNC_INTERVAL = 30_000;

/** Minimum delay between two consecutive scans (debounce). */
export const SCAN_DEBOUNCE = 2_000;

/** Time-to-live for the in-memory duplicate cache. */
export const CACHE_TTL = 3_600_000;

/** How often stale cache entries are evicted. */
export const CACHE_CLEAN_INTERVAL = 1_800_000;

// --- Network ---------------------------------------------------------------

/** Maximum time (ms) to wait for an API response before aborting. */
export const API_TIMEOUT = 5_000;

/** Maximum number of retry attempts for failed requests. */
export const MAX_RETRIES = 5;

/** Progressive back-off delays (ms) for each retry attempt. */
export const RETRY_DELAYS = [1_000, 2_000, 5_000, 10_000, 30_000] as const;

// --- Cryptography ----------------------------------------------------------

/** Interval (ms) between HMAC key rotations (7 days). */
export const KEY_ROTATION_INTERVAL = 7 * 24 * 60 * 60 * 1_000;

/** Number of PBKDF2 iterations for key derivation. */
export const PBKDF2_ITERATIONS = 100_000;

/** Base string used to derive the HMAC salt. */
export const SALT_BASE = 'sideview_qr_salt_base';

